import React, { useEffect, useState } from 'react';
import './WhatsappFloater.scss';
import { BRAND_DOMAIN } from '../../constants/Branding';
import WhatsupImg from '../../assets/images/footer/whatsup-flot.png';
import SVLS_API from '../../svls-api';
import { RootState } from '../../models/RootState';
import { connect } from 'react-redux';
import { DomainConfig } from '../../models/DomainConfig';

type StoreProps = {
  domainConfig: DomainConfig;
};
const WhatsappFloater: React.FC<StoreProps> = (props) => {
  const {  domainConfig } = props;
  const [regWhatsappLink, setRegWhatsappLink] = useState<string>();
  const handleMouseEnter = e => {
    document.getElementById('b').style.opacity = '1';
  }

  const handleMouseLeave = e => {
    document.getElementById('b').style.opacity = '0';
  }

  useEffect(() => {
    getContactDetails();
  },[])

  const getContactDetails = async () => {
    try {
      const response = await SVLS_API.get(`/account/v2/books/${BRAND_DOMAIN}/contact-list`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.status === 200) {
        response.data.map(i => {
          if (i.contactType === "REGISTRATION_WHATSAPP_LINK" && i.details !== ''){
            let checkLink = i.details;
            console.log("checkLink",checkLink);
            if((checkLink.indexOf('https://')> -1) || (checkLink.indexOf('http://')> -1)){
              setRegWhatsappLink(i.details);
            }else {
              setRegWhatsappLink(`http://api.whatsapp.com/send?phone=${i.details}`);
            }
          } 
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  
  return (
    <>
    {domainConfig.whatsapp && !window.location.hostname.includes("24betlive.com") ? (
    <div>
      <a 
        id='linkID'
        href={regWhatsappLink}
        target="_blank"
        className='whatsapp_option'
      >
       <div className='whatsapp_font_alg' id='b'>Play and Win.Get a new Id instantly over whatsapp</div>
       <img src={WhatsupImg} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className="whatsapp_icon_alg" />
      </a>
    </div>
    ):null}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    domainConfig: state.common.domainConfig
  };
};

export default connect(mapStateToProps)(WhatsappFloater) ;
